import MyEditor from "components/MyEditor";
import TextError from "components/typography/textError";
import TitleText from "components/typography/titleText";
import fn_helper from "helpers/fn_helper";
import React, { useState, useEffect, useRef } from "react";
import { CardSubtitle, Input, Label } from "reactstrap";

function InputTextEditor({
  id = "formId",
  placeholder = "",
  name = "formName",

  onChange = (e) => {
    console.log("onChange!");
  },
  onBlur = () => {
    console.log("onBlur!");
  },

  value = "",
  maxLength = 100,
  invalid = false,
  disabled = false,
  errorText = "",
  readOnly = false,
  title = "",
  subtitle = "",
  required = false,
  formik = {},
}) {
  const isFormik = Object.keys(formik).length > 0 //ik
  const handleOnChange = (event, editor) => {
    const newValue = editor.getData();
    console.log("newValue", newValue);
    // return
    if (isFormik) {
      formik.setFieldValue(name, newValue)
      onChange(newValue);
    } else {
      onChange(newValue);
    }
  };
  const handleOnBlur = (e) => {
    if (isFormik) {
      formik?.setFieldTouched(name, true);
      onBlur(e)
    } else {
      onBlur(e)
    }
  };

  if (isFormik) {
    value = formik?.values[name]
    invalid = formik.touched[name] && formik.errors[name]
    errorText = formik.errors[name]
    // required = fn_helper.FNPRODUCT.isFieldRequired(formik, name)
  }

  return (
    <>
      <div className={invalid ? "invalid-editor" : ""}>
        {title && (
          <div className="bSwitchGroup">
            {title && (
              <TitleText htmlFor={name}>
                {title}
                {required && <span className="t-require">*</span>}
              </TitleText>
            )}
            {subtitle && (
              <CardSubtitle className="mb-3">{subtitle}</CardSubtitle>
            )}
          </div>
        )}
        <MyEditor 
          value={value} 
          isError={invalid}
          onChange={handleOnChange}
          onBlur={handleOnBlur}
          disabled={disabled}
          minHeight={500}
        />
      </div>
      <TextError invalid={invalid} errorText={errorText} />
    </>
  );

  return (
    <>
      <div className="input-len-box">
        <Input
          id={id}
          className="form-control"
          type={type}
          rows="3"
          placeholder={placeholder}
          name={name}
          onChange={handleOnChange}
          onBlur={handleOnBlur}
          maxLength={maxLength}
          value={value}
          invalid={invalid}
          disabled={disabled}
          readOnly={readOnly}
        />
        {/* <p className="b-txt-count">{value.length}/{maxLength}</p> */}
        {errorText && invalid && (
          <div type="invalid" className="invalid-feedback d-block">
            {errorText}
          </div>
        )}
      </div>
    </>
  );
}
export default InputTextEditor;
